import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { WebSocketSessionzi1ianvyj32u as WebSocketSession } from '../../../../../../ktor-ktor-websockets/io/ktor/websocket/WebSocketSession.mjs';
import { DefaultWebSocketSession3h8506yqzs5fx as DefaultWebSocketSession } from '../../../../../../ktor-ktor-websockets/io/ktor/websocket/DefaultWebSocketSession.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_send__qhx0g0($this, frame, $completion) {
  var tmp = $this.o5v_1.f5a(frame, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_flush__owbk1c($this, $completion) {
  var tmp = $this.o5v_1.v4i($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var DefaultClientWebSocketSessionClass;
function DefaultClientWebSocketSession() {
  if (DefaultClientWebSocketSessionClass === VOID) {
    class $ {
      constructor(call, delegate) {
        this.o5v_1 = delegate;
        this.p5v_1 = call;
      }
      f5a(frame, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_send__qhx0g0.bind(VOID, this, frame), $completion);
      }
      v4i($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_flush__owbk1c.bind(VOID, this), $completion);
      }
      b5a(_set____db54di) {
        this.o5v_1.b5a(_set____db54di);
      }
      c5a() {
        return this.o5v_1.c5a();
      }
      d5a() {
        return this.o5v_1.d5a();
      }
      e5a() {
        return this.o5v_1.e5a();
      }
      ew() {
        return this.o5v_1.ew();
      }
      a5a(negotiatedExtensions) {
        this.o5v_1.a5a(negotiatedExtensions);
      }
      z59() {
        return this.o5v_1.z59();
      }
    }
    initMetadataForClass($, 'DefaultClientWebSocketSession', VOID, VOID, [WebSocketSession(), DefaultWebSocketSession()], [1, 0]);
    DefaultClientWebSocketSessionClass = $;
  }
  return DefaultClientWebSocketSessionClass;
}
function *_generator_send__qhx0g0_0($this, frame, $completion) {
  var tmp = $this.q5v_1.f5a(frame, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_flush__owbk1c_0($this, $completion) {
  var tmp = $this.q5v_1.v4i($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var DelegatingClientWebSocketSessionClass;
function DelegatingClientWebSocketSession() {
  if (DelegatingClientWebSocketSessionClass === VOID) {
    class $ {
      constructor(call, session) {
        this.q5v_1 = session;
        this.r5v_1 = call;
      }
      f5a(frame, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_send__qhx0g0_0.bind(VOID, this, frame), $completion);
      }
      v4i($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_flush__owbk1c_0.bind(VOID, this), $completion);
      }
      b5a(_set____db54di) {
        this.q5v_1.b5a(_set____db54di);
      }
      c5a() {
        return this.q5v_1.c5a();
      }
      d5a() {
        return this.q5v_1.d5a();
      }
      e5a() {
        return this.q5v_1.e5a();
      }
      ew() {
        return this.q5v_1.ew();
      }
    }
    initMetadataForClass($, 'DelegatingClientWebSocketSession', VOID, VOID, [WebSocketSession()], [1, 0]);
    DelegatingClientWebSocketSessionClass = $;
  }
  return DelegatingClientWebSocketSessionClass;
}
//region block: exports
export {
  DefaultClientWebSocketSession as DefaultClientWebSocketSession1n8ok3lng45wy,
  DelegatingClientWebSocketSession as DelegatingClientWebSocketSessiono1sywc6weckz,
};
//endregion

//# sourceMappingURL=ClientSessions.mjs.map
